import React from 'react';
import { Tag } from 'antd';
import moment from 'moment';

export function formatLegalAcceptedAt(value) {
  if (!value) {
    return '—';
  }
  return moment(value).format('MMM D, YYYY h:mm A');
}

export function LegalStatusTag({ acceptedAt }) {
  return acceptedAt ? (
    <Tag color="green">Accepted</Tag>
  ) : (
    <Tag color="orange">Pending</Tag>
  );
}

export const legalAcceptanceColumns = [
  {
    title: 'Terms',
    key: 'legal_status',
    filters: [
      { text: 'Accepted', value: 'accepted' },
      { text: 'Pending', value: 'pending' },
    ],
    onFilter: (value, record) =>
      value === 'accepted'
        ? Boolean(record.legal_accepted_at)
        : !record.legal_accepted_at,
    render: (text, record) => (
      <LegalStatusTag acceptedAt={record.legal_accepted_at} />
    ),
  },
  {
    title: 'Terms Accepted',
    dataIndex: 'legal_accepted_at',
    key: 'legal_accepted_at',
    sorter: (a, b) =>
      new Date(a.legal_accepted_at || 0) - new Date(b.legal_accepted_at || 0),
    render: (value) => formatLegalAcceptedAt(value),
  },
];
